'use strict';

function getStreamUrl(track) {
  var { sourceId } = track;

  // We can't use track.streamUrl directly because it might be 404.
  // Instead, let our server decide where to stream from.

  // In future, we might want to return an array of sources here
  // and switch to our server only if track.streamUrl actually fails.

  return `/api/media/redirect_to_stream?track_id=${sourceId}`;
}

module.exports = getStreamUrl;


/** WEBPACK FOOTER **
 ** ./utils/getStreamUrl.js
 **/